:host{display:flex;flex-direction:column;height:100%}app-add-edit-team{flex:1 1 auto}
/*# sourceMappingURL=add-edit-team-dialog.component-RCPEHGQF.css.map */
